import '@b3sa/b3-design-system-web';
import '@b3sa/b3-design-system-web/datepicker';
import '@b3sa/b3-design-system-web/input-area';
import '@b3sa/b3-design-system-web/drawer';
import '@b3sa/b3-design-system-web/modal';
import '@b3sa/b3-design-system-web/toast';
import '@b3sa/b3-design-system-web/input-select';
import '@b3sa/b3-design-system-web/input-search';
import '@b3sa/b3-design-system-web/table';
import '@b3sa/b3-design-system-web/pagination';
import '@b3sa/b3-design-system-web/toggle-button';
import '@b3sa/b3-design-system-web/tooltip';
import '@b3sa/b3-design-system-web/menu-vertical';
import '@b3sa/b3-design-system-web/logo';
import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { initializeB3DesignSystemTheme } from './app/shared/b3-design-system-web/b3-design-system-web.setup';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

initializeB3DesignSystemTheme();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
